import { Fragment, useCallback, memo, useMemo, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { useLocation } from 'react-router-dom';
import I18n from 'I18n';
import { TrellisEPHeader } from 'editor-components/header/EPHeader';
import EPNavigationBar from 'editor-components/header/EPNavigationBar';
import FormattedMessage from 'I18n/components/FormattedMessage';
import BreakpointsContainer from 'ContentEditorUI/containers/BreakpointsContainer';
import { toggleFocusMode } from 'ContentEditorUI/redux/actions/focusModeActions';
import { getIsFocusModeOn } from 'ContentEditorUI/redux/selectors/localCachedSettingsSelectors';
import ExitButton from 'ContentEditorUI/components/header/ExitButton';
import { getHasUnsavedChanges } from 'ContentEditorUI/redux/selectors/saveDataSelectors';
// @ts-expect-error not typed
import bus from 'ContentEditorUI/coffee/lib/eventBus';
// @ts-expect-error not typed
import { getLastSaveDate } from 'ContentEditorUI/redux/selectors/editingInfoSelectors';
import { getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getIsUserJitad } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getHasUndoRedoAccess } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { showLoading, hideLoading, openModal
// @ts-expect-error not typed
} from 'ContentEditorUI/redux/actions/appActions';
// @ts-expect-error not typed
import { routeToPage } from 'ContentEditorUI/redux/actions/routingActions';
import { setShouldClearHeaderActiveItem, updateHeaderActiveItem } from 'ContentEditorUI/redux/actions/headerActions';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
// @ts-expect-error not typed
import { updatePatagoniaSettingsModalActiveNavItem } from 'ContentEditorUI/redux/actions/baseSettingsActions';
// @ts-expect-error not typed
import BaymaxSaveButton from 'ContentEditorUI/components/header/BaymaxSaveButton';
import { getIsSavePermanentlyDisabled, getSaveState } from 'ContentEditorUI/redux/selectors/saveDataSelectors';
import { getShouldClearHeaderActiveItem } from 'ContentEditorUI/redux/selectors/headerSelectors';
import UndoRedoButtonContainer from 'ContentEditorUI/containers/UndoRedoButtonContainer';
import { getShouldUseResponsiveBreakpoints } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { getActiveHubDbRowId } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import ContentPublishStatus from 'ContentEditorUI/components/shared/ContentPublishStatus';
import ContentCrmObjectProvider from 'ContentEditorUI/components/publishing/ContentCrmObjectProvider';
import { Button } from 'foundations-components/transitional/components/Button';
import { SettingsIcon } from 'foundations-assets';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { AutoSizedTextInput } from 'foundations-components/transitional/components/AutoSizedTextInput';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { save } from '../actions/editorSaveActions';
import { useNavigationGroups } from '../hooks/useNavigationGroups';
import { updateInstanceValue } from 'structured-content-lib/redux/actions/instanceEditActions';
import { View } from 'foundations-components/components/View';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { deleteArticle } from '../../articles/api/articlesApi';
import { getCanSave, getHasPermissionToSave } from '../selectors/saveSelectors';
import { selectArticleTitle, selectInstanceValues, selectIsArticlePublished, selectArticleAIGenerated } from '../selectors/editorSelectors';
import { selectArticleTranslatedFromId, selectGroupId } from '../../settings/selectors/articleInstanceSelectors';
import { fetchKnowledgeBase } from '../../knowledge-bases/actions/knowledgeBaseActions';
import { getEditorUrl, getKnowledgeBaseManageUrl } from '../../utils/urls';
import DeleteArticleModal from './DeleteArticleModal';
import TranslationSelectorContainer from './TranslationsContainer';
import { selectPrimaryKnowledgeBase } from '../../settings/selectors/knowledgeBaseSelectors';
import { usageTracker } from '../../utils/usageTracker';
import ArticlePublishButtonContainer from './ArticlePublishButtonContainer';
import { ContentObjectTypes } from 'content-management-data-lib';
import { selectIsUngatedForLocalizationArticleTitle, selectIsUngatedForSchedulingWithContentCrmObject, selectIsUngatedForRevisionHistory } from '../../auth/selectors/auth';
import { AiArticleFeedback } from './AiArticleFeedback';
import { getDefaultArticleName } from '../../articles/constants/ArticleConstants';
import { useAppSelector } from '../../reducers';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorToolbarEndSlot = () => {
  const dispatch = useDispatch();
  const hasUnsavedChanges = useSelector(getHasUnsavedChanges);
  const savePermanentlyDisabled = useSelector(getIsSavePermanentlyDisabled);
  const isSavingEnabled = useSelector(getCanSave);
  const hasPermissionToSave = useSelector(getHasPermissionToSave);
  const saveState = useSelector(getSaveState);
  const lastSave = useSelector(getLastSaveDate);
  const isUserJitad = useSelector(getIsUserJitad);
  const isUngatedForRevisionHistory = useSelector(selectIsUngatedForRevisionHistory);
  const handlePreviewClick = useCallback(() => {
    if (hasUnsavedChanges) {
      dispatch(showLoading());
      dispatch(save()).finally(() => {
        dispatch(hideLoading());
        dispatch(routeToPage('preview'));
      }).catch(error => console.error(error));
    } else {
      dispatch(routeToPage('preview'));
    }
  }, [dispatch, hasUnsavedChanges]);
  const handleRevisionsClick = useCallback(() => {
    dispatch(routeToPage('revisions'));
  }, [dispatch]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(BaymaxSaveButton, {
      allowedSave: hasPermissionToSave,
      contentTypeNoun: I18n.text('knowledgeArticleEditorUI.categories.knowledgeArticle'),
      isDisabled: !isSavingEnabled,
      onSaveClick: () => dispatch(save()),
      permanentlyDisabled: savePermanentlyDisabled,
      isUngatedForPatagonia: true,
      shouldShowRevisions: isUngatedForRevisionHistory,
      onRevisionsClick: handleRevisionsClick,
      lastSave: lastSave,
      saveState: saveState,
      isUserJitad: isUserJitad
    }), /*#__PURE__*/_jsx(Button, {
      onClick: handlePreviewClick,
      use: "secondary-ghost",
      size: "small",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "components.tabBar.preview"
      })
    }), /*#__PURE__*/_jsx(ArticlePublishButtonContainer, {})]
  });
};
const HeaderContainer = /*#__PURE__*/memo(() => {
  const dispatch = useDispatch();
  const [isDeleteArticleModalOpen, setIsDeleteArticleModalOpen] = useState(false);
  const [isDeletingArticle, setIsDeletingArticle] = useState(false);
  const hasUndoRedoAccess = useSelector(getHasUndoRedoAccess);
  const isReadOnlyMode = useSelector(getIsReadOnlyMode);
  const knowledgeBaseGroupId = useSelector(selectGroupId);
  const primaryKnowledgeBase = useSelector(selectPrimaryKnowledgeBase);
  const isFocusModeOn = useSelector(getIsFocusModeOn);
  const primaryKnowledgeBaseIdWithFallback = primaryKnowledgeBase ? primaryKnowledgeBase.values.hs_id : knowledgeBaseGroupId;
  const primaryArticleId = useSelector(selectArticleTranslatedFromId);
  const shouldUseResponsiveBreakpoints = useSelector(getShouldUseResponsiveBreakpoints);
  const shouldClearHeader = useSelector(getShouldClearHeaderActiveItem);
  const pageName = useSelector(selectArticleTitle);
  const aiGenerated = useSelector(selectArticleAIGenerated);
  const isAiGenerated = Boolean(aiGenerated);
  const instanceValues = useSelector(selectInstanceValues);
  const handleDeleteArticle = useCallback(() => {
    setIsDeletingArticle(true);
    deleteArticle(instanceValues.hs_id).then(() => {
      setIsDeletingArticle(false);
      setIsDeleteArticleModalOpen(false);
      if (!primaryArticleId) {
        window.location.href = getKnowledgeBaseManageUrl(primaryKnowledgeBaseIdWithFallback);
      } else {
        // if this a translated article then redirect to primary article
        window.location.href = getEditorUrl(primaryArticleId);
      }
    }).catch(() => {
      setIsDeletingArticle(false);
      setIsDeleteArticleModalOpen(false);
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeArticleEditorUI.header.menus.deleteArticleError"
        }),
        type: 'danger'
      });
    });
  }, [instanceValues.hs_id, primaryKnowledgeBaseIdWithFallback, primaryArticleId]);
  const navigationGroups = useNavigationGroups({
    onDeleteClick: () => {
      setIsDeleteArticleModalOpen(true);
    }
  });
  useEffect(() => {
    if (knowledgeBaseGroupId) {
      dispatch(fetchKnowledgeBase(knowledgeBaseGroupId));
    }
  }, [dispatch, knowledgeBaseGroupId]);
  const handleActiveItemChange = useCallback(activeItem => {
    dispatch(updateHeaderActiveItem(activeItem));
    if (activeItem) {
      dispatch(setShouldClearHeaderActiveItem(false));
    }
  }, [dispatch]);
  const handleChangeName = ({
    currentTarget: {
      value: newName
    }
  }) => dispatch(updateInstanceValue('hs_name', newName));
  const setSettingsModalOpenWithNavItem = useCallback(navItem => {
    dispatch(updatePatagoniaSettingsModalActiveNavItem(navItem));
    dispatch(openModal(MODAL_TYPES.SETTINGS_MODAL));
  }, [dispatch]);
  function handleFocusMode(isChecked) {
    usageTracker.track('editorInteraction', {
      event: 'toggled focus mode',
      subtype: isChecked ? 'enabled' : 'disabled'
    });
    dispatch(toggleFocusMode(isChecked));
    bus.toggleEditorFocusMode(isChecked);
  }
  const exitUrl = useExitUrl(primaryKnowledgeBaseIdWithFallback);
  const isPublished = useSelector(selectIsArticlePublished);
  const articleCrmHubDbRowId = useSelector(getActiveHubDbRowId);
  const isUngatedForSchedulingWithContentCrmObject = useSelector(selectIsUngatedForSchedulingWithContentCrmObject);
  const isUngatedForLocalizationArticleTitle = useAppSelector(selectIsUngatedForLocalizationArticleTitle);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isDeleteArticleModalOpen && /*#__PURE__*/_jsx(DeleteArticleModal, {
      onConfirm: handleDeleteArticle,
      onReject: () => setIsDeleteArticleModalOpen(false),
      isDeletingArticle: isDeletingArticle,
      articleName: instanceValues.hs_name
    }), /*#__PURE__*/_jsx(ContentCrmObjectProvider, {
      contentObjectType: ContentObjectTypes.KNOWLEDGE_ARTICLE,
      contentCrmObjectId: articleCrmHubDbRowId,
      enableScheduledPublishing: isUngatedForSchedulingWithContentCrmObject,
      shouldUseContentCrmObject: isUngatedForSchedulingWithContentCrmObject,
      children: /*#__PURE__*/_jsx(TrellisEPHeader, {
        "data-test-id": "header-container",
        tabsStyles: {
          marginBlock: '0'
        },
        titleText: /*#__PURE__*/_jsxs(TFlex, {
          align: "center",
          justify: "center",
          direction: "column",
          children: [/*#__PURE__*/_jsxs(TFlex, {
            align: "center",
            justify: "center",
            direction: "row",
            gap: 8,
            children: [isAiGenerated && /*#__PURE__*/_jsx(AIBadge, {}), /*#__PURE__*/_jsx(AutoSizedTextInput, {
              error: !pageName,
              affordance: true,
              onChange: handleChangeName,
              use: "on-dark",
              value: pageName,
              readOnly: isReadOnlyMode,
              placeholder: getDefaultArticleName(isUngatedForLocalizationArticleTitle)
            })]
          }), /*#__PURE__*/_jsx(ContentPublishStatus, {
            isPublished: isPublished
          })]
        }),
        editorToolbarStartSlot: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(ExitButton, {
            dashboardUrl: exitUrl
          }), /*#__PURE__*/_jsx(EPNavigationBar, {
            navigationGroups: navigationGroups,
            onActiveItemChange: handleActiveItemChange,
            shouldClear: shouldClearHeader
          })]
        }),
        editorToolbarEndSlot: /*#__PURE__*/_jsx(EditorToolbarEndSlot, {}),
        tabsStartSlot: /*#__PURE__*/_jsx(TFlex, {
          align: "center",
          justify: "start",
          gap: 24,
          children: /*#__PURE__*/_jsx(TranslationSelectorContainer, {})
        }),
        tabsMiddleSlot: /*#__PURE__*/_jsxs(Fragment, {
          children: [shouldUseResponsiveBreakpoints && /*#__PURE__*/_jsx(BreakpointsContainer, {}), isAiGenerated && /*#__PURE__*/_jsx(AiArticleFeedback, {})]
        }),
        tabsEndSlot: /*#__PURE__*/_jsx(NavMarker, {
          name: "PARENT_APP_CHROME_RENDERED",
          children: /*#__PURE__*/_jsxs(TFlex, {
            align: "center",
            justify: "end",
            children: [/*#__PURE__*/_jsx(FormLabel, {
              htmlFor: "focus-mode-toggle",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeArticleEditorUI.focusModeToggleLabel"
              })
            }), /*#__PURE__*/_jsx(Toggle, {
              checked: isFocusModeOn,
              id: "focus-mode-toggle",
              onChange: ({
                target: {
                  checked
                }
              }) => handleFocusMode(checked),
              size: "small",
              padding: "200"
            }), /*#__PURE__*/_jsxs(Button, {
              "data-test-id": "settings",
              use: "tertiary-light",
              size: "medium",
              onClick: () => setSettingsModalOpenWithNavItem('general'),
              padding: "200",
              children: [/*#__PURE__*/_jsx(SettingsIcon, {
                size: "300"
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeArticleEditorUI.settingsLabel"
              })]
            }), !!hasUndoRedoAccess && /*#__PURE__*/_jsx(View, {
              marginInlineStart: "100",
              children: /*#__PURE__*/_jsx(UndoRedoButtonContainer, {
                isVisible: true,
                disabled: isReadOnlyMode
              })
            })]
          })
        })
      })
    })]
  });
});
export default HeaderContainer;
function useExitUrl(knowledgeBaseId) {
  const {
    search
  } = useLocation();
  const redirectParam = useMemo(() => new URLSearchParams(search).get('redirectUrl'), [search]);
  return isValidExitUrlParam(redirectParam) ? redirectParam : getKnowledgeBaseManageUrl(knowledgeBaseId);
}
function isValidExitUrlParam(redirectParam) {
  return redirectParam ? redirectParam.startsWith('/') && !redirectParam.startsWith('//') : false;
}